import React from 'react';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Header } from 'shared/components/header';

import {
  BreadcrumbContainer,
  BreadcrumbLink,
  BreadcrumbText,
  ContentContainer,
  PageWrapper,
  TextBody,
  Title,
} from './styles';
import { Box } from '@mui/material';

export const PrivacyPolicyPage: React.FC = () => {
  return (
    <Box>
      <Header />
      <PageWrapper>
        <BreadcrumbContainer>
          <BreadcrumbLink href="/">Início</BreadcrumbLink>
          <ChevronRightIcon sx={{ fontSize: 16, color: '#0e77da' }} />
          <BreadcrumbText>Políticas de Privacidade</BreadcrumbText>
        </BreadcrumbContainer>

        <ContentContainer>
          <Title>Políticas de Privacidade</Title>
          <TextBody>
            <div>
              Política de Privacidade da plataforma de financiamento Dimo da Motorola. Sua privacidade é importante para
              nós. Esta política descreve como coletamos, usamos e protegemos suas informações pessoais.
            </div>
            <div>
              1. COLETA DE INFORMAÇÕES <br />
              Coletamos informações pessoais que você nos fornece diretamente ao preencher o formulário de solicitação,
              incluindo: nome completo, CPF, e-mail, telefone e renda mensal. Também podemos coletar informações
              automaticamente sobre seu uso da plataforma.
            </div>
            <div>
              2. USO DAS INFORMAÇÕES <br />
              Suas informações são usadas para: Processar sua solicitação de financiamento e análise de crédito; Entrar
              em contato com você sobre sua proposta e andamento do processo; Enviar comunicações de marketing (quando
              autorizado); Melhorar nossos serviços e experiência do usuário; Cumprir obrigações legais e regulatórias;
              Prevenir fraudes e garantir a segurança da plataforma.
            </div>

            <div>
              3. COMPARTILHAMENTO DE DADOS <br />
              Seus dados podem ser compartilhados com: Banco Arbi S/A (CNPJ 54.403.563/0001-50) - parceiro responsável
              pela análise e concessão de crédito; Instituições financeiras, birôs de crédito e Sistema de Informações
              de Crédito (SCR) do Banco Central; Prestadores de serviços que auxiliam na operação da plataforma;
              Autoridades governamentais quando exigido por lei ou decisão judicial.
            </div>

            <div>
              4. SEGURANÇA <br />
              Implementamos medidas de segurança técnicas e organizacionais adequadas para proteger suas informações
              contra acesso não autorizado, alteração, divulgação ou destruição. Utilizamos criptografia SSL/TLS para
              transmissão de dados sensíveis.
            </div>

            <div>
              5. SEUS DIREITOS (LGPD) <br />
              De acordo com a Lei Geral de Proteção de Dados (Lei nº 13.709/2018), você tem direito a: Confirmar a
              existência de tratamento de dados pessoais; Acessar seus dados pessoais; Corrigir dados incompletos,
              inexatos ou desatualizados; Solicitar a anonimização, bloqueio ou eliminação de dados; Solicitar a
              portabilidade dos dados; Revogar o consentimento a qualquer momento; Obter informações sobre com quem
              compartilhamos seus dados.
            </div>

            <div>
              6. RETENÇÃO DE DADOS <br />
              Manteremos seus dados pessoais pelo período necessário para cumprir as finalidades descritas nesta
              política, exceto se um período de retenção maior for exigido ou permitido por lei.
            </div>

            <div>
              7. COOKIES E TECNOLOGIAS SIMILARES <br />
              Utilizamos cookies e tecnologias similares para melhorar sua experiência, analisar o uso da plataforma e
              personalizar conteúdo. Você pode gerenciar preferências de cookies nas configurações do seu navegador.
            </div>

            <div>
              8. CONTATO <br />
              Para exercer seus direitos, fazer perguntas sobre privacidade ou entrar em contato com nosso Encarregado
              de Proteção de Dados (DPO), utilize nossos canais de atendimento.
            </div>

            <div>Data da última atualização: 04 de fevereiro de 2026</div>
          </TextBody>
        </ContentContainer>
      </PageWrapper>
    </Box>
  );
};
